import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../../Global/Header";
import Footer from "../../Global/Footer";
import Sidebar from "./Sidebar";

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col bg-[#f4f8fb]">
      <Header />
      <Sidebar />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
